import { addStudent, queryCourseType, queryCourseList } from '@/api'
import { Toast } from 'vant'
// addStudent 添加学生
export default {
  components: {},
  props: [],
  name: 'resetPassword-page',
  data () {
    return {
      user: {
        idCard: '',
        name: '',
        courseId: '',
        courseTypeId: ''
      },
      coursename: null,
      currenPage: 1,
      allPage: 1,
      option: [],
      option1: [],
      showCourse: false,
      showCoursetype: false,
      time: null,
      loading: false,
      finished: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    this.getCourseType()
  },
  mounted () { },
  destroyed () { },
  methods: {
    // 获取项目类型
    async getCourseType () {
      const { data } = await queryCourseType()
      this.option = data
    },
    // 获取项目列表
    async getCourseList () {
      const { data } = await queryCourseList({
        courseType: this.user.courseTypeId,
        name: this.coursename,
        idCard: this.user.idCard,
        page: this.currenPage,
        limit: 20
      })
      this.allPage = data.allPage
      this.currenPage += 1
      this.option1 = [...data.courseList, ...this.option1]
    },
    getCourse () {
      this.currenPage = 1
      this.allPage = 1
      this.option1 = []
      this.onLoad()
    },
    changeType () {
      this.showCoursetype = true
    },
    clicktypeli (item) {
      this.user.courseTypeId = item.id
      this.showCoursetype = false
      this.user.courseId = null
      this.coursename = null
    },
    clicknameli (item) {
      this.showCourse = false
      this.user.courseId = item.id
      this.coursename = item.name
    },
    onLoad () {
      clearTimeout(this.time)
      this.time = setTimeout(() => {
        if (!this.user.courseTypeId || !this.coursename) return
        if (this.currenPage > this.allPage) {
          this.finished = true
        } else {
          this.getCourseList()
          this.showCourse = true
          this.finished = false
        }
        this.loading = false
      }, 800)
    },
    async sureClick () {
      if (!this.user.name) { Toast({ message: '学生名不能为空', type: 'fail' }); return }
      if (!this.user.idCard) { Toast({ message: '学生识别号不能为空', type: 'fail' }); return }
      if (!this.user.courseId) { Toast({ message: '项目名不能为空', type: 'fail' }); return }
      if (!this.user.courseTypeId) { Toast({ message: '项目类型不能为空', type: 'fail' }); return }
      const { error } = await addStudent(this.user)
      if (error.returnCode !== 0) {
        Toast({ message: '对不起，学生个人信息输入有误', type: 'fail' })
      } else {
        Toast({ message: '绑定成功', type: 'success' })
        this.$router.push({ path: '/adviserHomePage' })
        this.user = {
          idCard: '',
          name: '',
          courseId: '',
          courseTypeId: ''
        }
        this.coursename = null
      }
    }
  }
}
